<template>
  <el-container style="height: 500px">
    <el-container style="width: 80%">
      <el-header style="text-align: left; background-color: white">
        <el-button size="small" type="primary" @click="dialogCreatGroup = true"
          >上传视频</el-button
        >
      </el-header>
      <el-main>
        <el-row :gutter="20">
          <el-col
            :span="24"
            :lg="4"
            :md="6"
            :sm="8"
            v-for="(item, index) in imageList"
            :key="index"
          >
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="border" :class="{ 'border-danger': item.ischeck }">
                <div class="box">
                  <video
                    ref="videoPlayer"
                    class="video-js"
                    style="width: 157px"
                    controls
                    controlslist="nodownload"
                    @play="toPlays"
                    @timeupdate="updateTime"
                    @pause="toPause"
                  >
                    <source :src="item.videoUrl" type="video/mp4" />
                  </video>
                  <div
                    style="
                      width: 140px;
                      height: 20px;
                      background: rgba(255, 255, 255, 0);
                      margin: -15px 2px;
                      position: absolute;
                    "
                  >
                    <span v-text="item.videoName" @click="choose(item)"></span>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

    <el-dialog
      title="添加视频"
      :visible.sync="dialogCreatGroup"
      width="40%"
      close-on-click-modal="true"
      show-close="true"
    >
      <el-form
        :model="flashPromotion"
        ref="flashPromotionForm"
        label-width="82px"
        size="small"
      >
        <el-form-item label="视频名称：">
          <el-input
            v-model="flashPromotion.videoName"
            style="width: 277px"
          ></el-input>
        </el-form-item>
        <el-upload
          class="upload-demo"
          drag
          :headers="myHeaders"
          :multiple="false"
          action="http://www.yeedawu.com:9010/fileManager/uploadFile"
          :on-success="onUpLoadSuccess"
          :on-error="onUploadFail"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将视频拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            只能上传视频文件，且不超过10M,否则会影响预览速度
          </div>
        </el-upload>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCreatGroup = false">取 消</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import {
  getPhotoGroup,
  getPhotosInGroup,
  upLoadPhotosInGroup,
} from "../../api/photoRequest";
import {
  creatGroup,
  deleteGroup,
  updateGroup,
} from "../../api/homePageRequest";
import { getToken } from "../../utils/auth";
import {
  query,
  create,
  update,
  deleteVideo,
  detail,
} from "@/api/introduceVideo";
const defaultFlashPromotion = {
  videoName: null,
  videoUrlBid: null,
};
const defaultListQuery = {
  pageNum: 1,
  pageSize: 1000,
};
export default {
  name: "PickVideoAlert",
  data() {
    return {
      inputSearch: "",
      timer: null, // 这里放外面其实不安全，容易被篡改
      resultList: [], // 最终要渲染的内容数组
      isShow: false, // 控制下拉列表的显示与隐藏
      tableData: [],
      originData: [],
      imageList: [],
      chooseList: [],
      currentRow: 0,
      dialogCreatGroup: false,
      currentGroupName: "",
      currentGroupId: -1,
      flashPromotion: Object.assign({}, defaultFlashPromotion),
      listQuery: Object.assign({}, defaultListQuery),
      checked: true,
      videoList: [],
    };
  },
  props: {
    maxSelected: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.tableData = this.originData;
    this.getGroup();
  },
  methods: {
    getSubStr(str) {
      var clipStr = str.split(".")[0];
      var subStr1 = clipStr.substr(0, 2);
      var subStr2 = clipStr.substr(clipStr.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    toPlay() {
      this.$refs.videoPlayer.paused === true
        ? this.$refs.videoPlayer.play()
        : this.$refs.videoPlayer.pause();
    },
    toForward() {
      var time = 10; //单位秒，每次增减10秒
      this.$refs.videoPlayer.volume !== this.$refs.videoPlayer.duration
        ? (this.$refs.videoPlayer.currentTime += time)
        : 1;
    },
    toBack() {
      var time = 10;
      console.log("后退");
      this.$refs.videoPlayer.currentTime !== 0
        ? (this.$refs.videoPlayer.currentTime -= time)
        : 1;
    },
    addVoice() {
      var vol = 0.1;
      console.log("增加音量");
      this.$refs.videoPlayer.volume !== 1
        ? (this.$refs.videoPlayer.volume += vol)
        : 1;
    },
    decrease() {
      var vol = 0.1;
      console.log("减小音量");
      this.$refs.videoPlayer.volume !== 0
        ? (this.$refs.videoPlayer.volume -= vol)
        : 1;
    },
    onUpLoadSuccess(resp) {
      if (!this.flashPromotion.videoName) {
        this.$message({
          type: "info",
          message: "请输入视频名称",
        });
        return;
      }
      //this.testReport.testReportBid = resp.data;
      this.$confirm("是否上传视频?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.dialogCreatGroup = false;
          this.flashPromotion.videoUrlBid = resp.data;
          create(this.flashPromotion).then((response) => {
            this.$message({
              type: "success",
              message: "上传成功!",
            });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "上传视频失败！",
          });
          this.getList();
        });
    },
    onUploadFail() {
      this.$msg.error("上传视频失败！");
    },
    updateGroupAction() {
      if (this.currentGroupId === -1) {
        creatGroup({
          groupName: this.currentGroupName,
          groupType: "photo",
        }).then((res) => {
          this.$message({
            type: "success",
            message: "创建成功！",
          });
          this.currentGroupName = "";
          this.currentGroupId = -1;
          this.dialogCreatGroup = false;
          this.getGroup();
        });
      } else {
        updateGroup({
          groupId: this.currentGroupId,
          groupName: this.currentGroupName,
        }).then((response) => {
          this.$message({
            type: "success",
            message: "更新成功！",
          });
          this.currentGroupName = "";
          this.currentGroupId = -1;
          this.dialogCreatGroup = false;
          this.getGroup();
        });
      }
    },
    deleteGroupAction() {
      if (this.currentGroupId === -1) return;
      deleteGroup(this.currentGroupId).then((res) => {
        this.$message({
          type: "success",
          message: "删除成功！",
        });
        this.currentGroupName = "";
        this.currentGroupId = -1;
        this.dialogCreatGroup = false;
        this.getGroup();
      });
    },
    editGroup(group) {
      this.currentGroupName = group.groupName;
      this.currentGroupId = group.groupId;
      this.dialogCreatGroup = true;
    },
    creatGroup() {
      this.currentGroupName = "";
      this.currentGroupId = -1;
      this.dialogCreatGroup = true;
    },
    // 选中图片
    choose(item) {
      console.log(item);
      // 选中功能
      if (!item.ischeck) {
        if (!(this.chooseList.length < this.maxSelected)) {
          this.$message.error("最多选择" + this.maxSelected + "个视频");
          return;
        }
        this.chooseList.push({
          fileBid: item.videoBid,
          fileUrl: item.videoUrl,
          name: item.videoName,
        });
        item.checkOrder = this.chooseList.length;
        item.ischeck = true;
        return;
      } else {
        // 取消选中
        // 找到在chooseList中的索引，删除
        let newAttr = [];
        let order = -1;
        for (let i = 0; i < this.chooseList.length; i++) {
          if (this.chooseList[i].fileBid === item.videoBid) {
            order = i;
            continue;
          }
          newAttr.push(this.chooseList[i]);
        }
        this.chooseList = newAttr;
        console.log(order);
        console.log(this.chooseList.length);
        for (let i = 0; i < this.imageList.length; i++) {
          if (i === order) {
            this.imageList[i].ischeck = false;
            this.imageList[i].checkOrder = 0;
          }
        }
        item.ischeck = false;
        item.checkOrder = 0;
      }
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange(val) {
      this.imageList = [];
      this.currentRow = val;
      query(this.listQuery).then((response) => {
        let images = [];
        for (let i = 0; i < response.data.records.length; i++) {
          let item = response.data.records[i];
          item.ischeck = false;
          item.checkOrder = 0;
          images.push(item);
        }
        this.imageList = images;
        console.log(this.imageList);
      });
    },
    onInput() {
      this.isShow = true;
      // 防抖
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.fSearch();
      }, 200);
    },
    fSearch() {
      this.tableData = this.originData;
      if (this.inputSearch.length > 0) {
        var currentDatas = [];
        for (let i = 0; i < this.tableData.length; i++) {
          let item = this.tableData[i];
          if (item.date.includes(this.inputSearch)) {
            currentDatas.push(item);
          }
        }
        this.tableData = currentDatas;
      }
    },
    handleSelect(item) {
      this.obj[this.name] = item.id + ""; // 选中后给对应字段赋值
      this.isShow = false; // 选中某一项后隐藏下拉列表框
    },
    getGroup() {
      getPhotoGroup().then((response) => {
        this.originData = response.data;
        this.tableData = this.originData;
        this.handleCurrentChange(response.data[0]);
      });
    },
    uploadNewPhoto(item) {
      let groupId = this.currentRow.groupId;
      let formData = new FormData();
      formData.append("file", item.file);
      upLoadPhotosInGroup(groupId, item.file.name, formData, getToken())
        .then((req, res) => {
          this.handleCurrentChange(this.currentRow);
        })
        .catch((error) => {
          this.$message.error("上传失败，请重新上传");
          console.log("报错", error);
        });
    },
    imageEdit(item, index) {},
  },
};
</script>

<style lang="scss" scoped>
.border {
  border: 2px solid white;
}
.border-danger {
  border: 2px solid #67c23a;
}
.el-card {
  margin-bottom: 20px;
}
.box {
  width: 100%;
  height: 120px;
  background: aliceblue;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
